import { v4 as uuidv4 } from 'uuid';
import { FlexLayoutCol, FlexLayoutRow } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { RichText } from '../../../../vtex-apps/rich-text/RichText/default';
import { Image } from '../../../../vtex-apps/store-components/Image/default';
import { VisibilityLayout } from '../../../../vtex-apps/VisibilityLayout/default';

const InstitutionalGroup = () => {
	return {
		componentName: 'VisibilityLayout',
		componentGroup: 'InstitutionalGroup',
		componentId: uuidv4(),
		variables,
		props: VisibilityLayout({ mzTitle: 'MZ | Conteúdo Institucional (On/Off)' }).props,
		childrenComponents: [
			FlexLayoutRow(
				{ colSizing: 'equal', blockClass: 'img-and-text__row-container-3', preventHorizontalStretch: true },
				[
					FlexLayoutCol({ width: { desktop: 'grow', mobile: '100%' }, blockClass: 'img-and-text__row-3' }, [
						RichText({
							blockClass: 'img-and-text__top-text-3',
							text: 'Texto de **Exemplo**\n\n\n Digite aqui seu texto',
						}),
					]),
					FlexLayoutCol(
						{
							width: { desktop: 'grow', mobile: '100%' },
							horizontalAlign: 'center',
							blockClass: 'img-and-text__row-3',
						},
						[
							Image({
								blockClass: 'img-and-text__image-3',
								src: 'https://hefesto-upload-images.s3.amazonaws.com/1683060245014-Slider-Banner-Mobile.png',
							}),
						],
					),
					FlexLayoutCol({ width: { desktop: 'grow', mobile: '100%' }, blockClass: 'img-and-text__row-3' }, [
						RichText({
							blockClass: 'img-and-text__bottom-text-3',
							text: 'Texto de **Exemplo**\n\n\n Digite aqui seu texto',
						}),
					]),
				],
			),
		],
	};
};

const variables = [
	{
		type: 'color',
		list: [
			{ from: '--white', to: '--iat-3-bg-color', name: 'Background' },
			{ from: '--text-color-1', to: '--iat-3-text-top-color', name: 'Text Top' },
			{ from: '--text-color-1', to: '--iat-3-text-bottom-color', name: 'Text Bottom' },
		],
	},
	{
		type: 'borderRadius',
		list: [{ from: '--border-radius-none', to: '--iat-3-img-border', name: 'Image' }],
	},
	{
		type: 'typography',
		list: [
			{ from: '--main-font', to: '--iat-3-typography-top', name: 'Text Top' },
			{ from: '--main-font', to: '--iat-3-typography-bottom', name: 'Text Bottom' },
		],
	},
];

export default InstitutionalGroup;
